export default "__VITE_ASSET__DdJKlFbU__"